import { TextField } from "@mui/material";

export default (props) => {
  return <TextField variant="outlined" {...props} />;
};
